var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radar-chart-container"},[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdfImageReady),expression:"!pdfImageReady"}],ref:"radarCanvas"}),(_vm.pdfImageReady)?_c('img',{staticClass:"chart-image",attrs:{"src":_vm.chartImageData}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }